import styled, { css } from 'styled-components'

interface IWrapperProps {
  $fullWidth?: boolean
  $height?: string
}

export const Wrapper = styled.div<IWrapperProps>`
  position: relative;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '247px')};
  height: ${({ $height, $fullWidth }) =>
    $height || ($fullWidth ? '160px' : '208px')};

  > span {
    display: block;
    width: 100%;
    height: 100%;
  }

  > span > div {
    height: 100%;
    width: 100%;
  }

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      .ant-upload {
        display: block;
        width: 100%;
        height: 100%;
      }
    `}
`

interface IImageProps {
  url: string
  $imageFit?: 'cover' | 'contain'
  $backgroundColor?: string
}

export const Image = styled.div<IImageProps>`
  background-image: url(${(props) => props.url});
  background-size: ${({ $imageFit = 'cover' }) => $imageFit};
  background-repeat: no-repeat;
  background-position: center center;
  background-color: ${({ $backgroundColor = '#ccc' }) => $backgroundColor};
  border-radius: 4px;
  height: 100%;
  transition: 200ms;
  box-shadow: 0px 4px 8px 0px #00000014;
`

export const RemoveImage = styled.div`
  float: right;
  margin-top: -7px;
  margin-right: -7px;
  svg {
    padding: 5px 7.7px;
    border-radius: 50%;
    color: #4c4c4c;
    background-color: white;
    box-shadow: 0px 4px 8px 0px #00000014;
    transition: 0.2s;
    cursor: pointer;
  }
  &:hover {
    svg {
      color: #757575;
    }
  }
`

interface IContainerProps {
  imageloaded: string
  $fullWidth?: boolean
  $hasError?: boolean
}

export const Container = styled.div<IContainerProps>`
  text-align: center;
  border: 2px dashed ${({ $hasError }) => ($hasError ? '#f5222d' : '#d9d9d9')};
  padding: ${({ $fullWidth, imageloaded }) => {
    if (!$fullWidth) return '8px'
    return imageloaded === 'true' ? '12px' : '20px'
  }};
  border-radius: 4px;
  height: 100%;
  transition: 200ms;
  ${(props) =>
    props.imageloaded === 'false' &&
    css`
      cursor: pointer;
      &:hover {
        border-color: ${props.$hasError ? '#f5222d' : '#2684ff'};
      }
    `}
`

export const Content = styled.div<{ $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'calc(100% - 20px)')};
  position: absolute;
  top: 50%;
  left: ${({ $fullWidth }) => ($fullWidth ? '0' : 'auto')};
  transform: translate(0, -50%);

  button {
    margin-top: 5px;
    color: #2684ff;
    font-weight: 700;
  }
`

export const IconWrapper = styled.div<{ $fullWidth?: boolean }>`
  width: ${({ $fullWidth }) => ($fullWidth ? '56px' : '72px')};
  height: ${({ $fullWidth }) => ($fullWidth ? '56px' : '72px')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin: 0 auto;

  svg {
    background-color: white;
    border-radius: 8px;
    color: #757575;
    padding: ${({ $fullWidth }) => ($fullWidth ? '8px' : '10px')};
    width: ${({ $fullWidth }) => ($fullWidth ? '16px' : '20px')};
    height: ${({ $fullWidth }) => ($fullWidth ? '16px' : '20px')};
  }
`

export const Title = styled.div<{ $fullWidth?: boolean }>`
  margin-top: ${({ $fullWidth }) => ($fullWidth ? '8px' : '16px')};
  color: #757575;
  font-size: 14px;
  line-height: 20px;
`

export const Subtitle = styled.div`
  color: #757575;
`
